import React, { memo, useMemo } from "react"
import PropTypes from "prop-types"
import TransitionLink from "gatsby-plugin-transition-link"

const CustomLink = ({ children, to, path }) => {
  const linkProps = useMemo(() => {
    const propObj = { className: "pointer-events-none" }
    if (path !== to) delete propObj.className
    return propObj
  }, [path, to])

  return (
    <TransitionLink to={to} exit={{ length: 1 }} {...linkProps}>
      {children}
    </TransitionLink>
  )
}

CustomLink.propTypes = {
  children: PropTypes.node,
  to: PropTypes.string,
  path: PropTypes.string,
}

export default memo(CustomLink)
